export const AdminAPIResource = {
  /** Authenticated with X-API-Key (REACT_APP_API_KEY) */
  listCustomers: "/v1/customers",
  /** Authenticated with X-API-Key (REACT_APP_API_KEY) */
  customerDetail: "/v1/customers/{customerId}",
  /** Authenticated with X-API-Key (REACT_APP_API_KEY) */
  documentDownloadUrl: "/v1/customers/{customerId}/documents/download-url",
  /** Authenticated with X-API-Key (REACT_APP_API_KEY) */
  reportDownload: "/v1/files/reports/{kycStatusGroup}/download/{customerSource}",
  /** Authenticated with X-API-Key (REACT_APP_API_KEY) */
  adminAccessCheck: "/v1/admin/access/check",
  /** Authenticated with X-API-Key (REACT_APP_API_KEY) */
  adminAccessRequest: "/v1/admin/access/request",
  /** Authenticated with X-API-Key (REACT_APP_API_KEY) */
  nameMatchEvaluate: "/v1/admin/name-match/evaluate",
};

export type CustomerSource = "BRP" | "SEMINIS";

export type DocumentType = "PAN_CARD_PROOF" | "BANK_ACCOUNT_PROOF";

export type KycStatusGroup = "NON_VERIFIED" | "ON_HOLD" | "VERIFIED";
